import { inject, Injectable, signal } from '@angular/core';
import { useMutation } from '@globalconnect/query';
import { FeedbackAlertService } from '../../../../feedback-alert/service/feedback-alert.service';
import { RolloutProgressReportsApiService } from '../api/rollout-progress-reports-api.service';
import { RolloutProgressReportsService } from '../rollout-progress-reports.service';

type UpdateReportCommentCallbacks = {
  onSuccess?: () => void;
  onError?: () => void;
};
@Injectable({
  providedIn: 'root',
})
export class ReportCommentService {
  private readonly apiService = inject(RolloutProgressReportsApiService);
  private readonly reportService = inject(RolloutProgressReportsService);
  private readonly feedbackAlertService = inject(FeedbackAlertService);

  private readonly _reportComment = signal(
    this.reportService.storedReportData().comment,
  );
  readonly reportComment = this._reportComment.asReadonly();

  updateV3ReportComment$ = (callbacks?: UpdateReportCommentCallbacks) =>
    useMutation(
      () =>
        this.apiService.updateV3ReportComment(
          this.reportService.reportId(),
          this._reportComment(),
        ),
      {
        onSuccess: (reportResponse) => {
          this.reportService.setStoredReportData(reportResponse);
          this.onCommentChange(reportResponse.comment);
          this.feedbackAlertService.showAlert(
            'success',
            'feedbackAlert.save.success',
          );

          callbacks?.onSuccess?.();
        },
        onError: (err) => {
          console.error(err);
          this.feedbackAlertService.showAlert(
            'critical',
            'feedbackAlert.save.error',
          );

          callbacks?.onError?.();
        },
      },
    );

  onCommentChange = (newComment: string): void => {
    this._reportComment.set(newComment);
  };

  resetComment = (): void =>
    this._reportComment.set(
      this.reportService.storedReportData().comment ?? '',
    );
}
